import { TbsDateAdapter } from '@ngx-terabase/ui/date-picker';
import moment, { Moment } from 'moment-timezone';

export class MomentDateAdapter implements TbsDateAdapter<Moment> {
  public toModel(value: Moment | null): Date | null {
    return value ? value.toDate() : null;
  }
  public toExternal(value: Date | null): Moment | null {
    return moment(value);
  }
}
